<script setup lang="ts">
import {endpoints} from "~/constants/endpoints";
import ContactUs from '~/components/custom-ui/ContactUs.vue'

definePageMeta({
    name: "faq_article",
})

const route = useRoute();
const config = useRuntimeConfig()

const {data: articleData} = await useAsyncData(`faq_article_${route.params.article}`,
    () => fetchData(endpoints.faq.single(route.params.article), {
        method: 'GET',
    })
        .then(({data, meta}) => data)
        .catch(error => console.log(error))
);

useSeoMeta({
    robots: 'index, follow',
    title: articleData.value?.title,
    ogUrl: () => config.public.frontUrl + route.path,
    ogTitle: () => articleData.value?.title,
    twitterTitle: () => articleData.value?.title,
})

useHead({
    link: [
        {
            rel: 'canonical',
            href: config.public.frontUrl + route.path,
        },
    ],
})

const { parseMarkdown } = useMarkdown()
const parsedContent = computed(() => parseMarkdown(articleData.value?.text))

// {{ route.params.id }} {{ route.params.article }}

</script>

<template>
  <div style="height: 100%">
    <div style="min-height: 100vh; display: flex; flex-direction: column;">
      <div style="flex-grow: 1;">
        <div class="container mx-auto px-4 my-10">
          <div class="grid place-items-center items-center mx-3">
            <div class="ys-home-card grid place-items-center my-10 w-full">
              <div class="ys-description-text flex justify-center items-center">
                <Icon size="24"
                      @click="navigateTo('/')"
                      class="menu-item-icon mr-1 text-gray-500 cursor-pointer"
                      name="ri:home-smile-2-line"/>
                <Icon size="24" class="menu-item-icon mr-1 text-gray-300" name="ri:arrow-right-s-line"/>

                <NuxtLink :to="{ name: 'faq'}"
                           class="text-xl text-zinc-600 cursor-pointer">{{ $t("Help & Support") }}</NuxtLink>

                <Icon size="24" class="menu-item-icon mr-1 text-gray-300" name="ri:arrow-right-s-line"/>

                <NuxtLink :to="{ name: 'faq_category', params: {id: route.params.id} }"
                           class="text-xl text-zinc-600 cursor-pointer">{{ articleData.title }}</NuxtLink>

              </div>
              <p class="ys-help-title-text" style="width: 510px">{{ articleData.title }}</p>
              <NuxtImg src="SupportPage/books.png" width="166" height="84" alt="Description" ondragstart="return false;"
                       oncontextmenu="return false;"/>
            </div>
            <div class="flex flex-wrap items-center justify-center max-w-[900px]">
                <div v-if="parsedContent" class="page_content" v-html="parsedContent"></div>
              
              <div v-if="articleData?.images?.length" class="flex flex-wrap items-center justify-center">
                <div v-for="item in articleData.images">
                <img width="400" class="m-2 border-2 rounded-2xl border-zinc-500" :src="item.image" alt="">
                </div>
              </div>
<!--              <nuxt-link v-for="item in articlesList"-->
<!--                         :to="{name: 'help-id-article-id', params: {id: item.id} }"-->
<!--                         class="ys-support-theme-box flex items-center justify-between my-2 mx-1.5 cursor-pointer">-->
<!--                <p class="ys-text">{{ item.title }}</p>-->
<!--                <div class="icon-container">-->
<!--                  <Icon size="24" name="ri:arrow-right-s-line"/>-->
<!--                </div>-->
<!--              </nuxt-link>-->
            </div>
          </div>
          <ContactUs/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.ys-about-card-end {
  height: 261px;
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
}

.icon-container {
  width: 40px;
  height: 40px;
  padding: 6px 8px 6px 8px;
  gap: 10px;
  border-radius: 96px;
  border: 1px solid rgba(226, 228, 233, 1);
}

.ys-support-theme-box {
  padding: 16px 32px 16px 32px;
  gap: 30px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(226, 228, 233, 1);
}


.ys-home-card {
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
  padding: 32px;
  gap: 30px;
}

.ys-help-title-text {
  font-family: Involve, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-size: 34px;
  font-weight: 400;
  line-height: 45px;
  text-align: center;
}

.ys-help-custom-title-text {
  font-family: Involve, sans-serif;
  font-style: italic;
  color: rgba(58, 62, 89, 1);
  font-size: 34px;
  font-weight: 500;
  line-height: 45px;
  text-align: left;
}


.ys-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: rgba(0, 0, 0, 1);
}

.ys-text-custom {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(0, 0, 0, 1);
}

</style>